import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link TableComponent}
 */
@Component({
  templateUrl: './bootstrap-table-demo.component.html',
  styleUrls: ['./bootstrap-table-demo.component.scss'],
})
export class BootstrapTableDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/table/bootstrap-table/bootstrap-table-demo.component.ts